import { Component, GameObject } from "../../tsthree";
import { Graphics, Sprite, Text, TextStyle, Texture } from "pixi.js";
import {GAME_FONT} from "../Constants/Constants";
import {buttonify} from "../../engine/HelperFunctions/buttonify";
import { tsthreeConfig } from "../../config/tsthreeConfig";
import { DOUBLE_CLICK_TIMER } from "../Constants/SharedConstants";

export class Windows95Desktop extends GameObject {
    constructor(
        desktopIcons: Array<{
            name: string;
            icon: Texture;
            onClick: () => void;
            components?: Array<Component>
        }>
    ) {
        super();

        const bg = new Sprite(
            ENGINE.getPIXIResource("doctos-flag") as Texture);
        bg.anchor.set(0.5);
        bg.scale.set(1.3);
        bg.position.set(tsthreeConfig.width * 0.5, tsthreeConfig.height * 0.45);
        bg.alpha = 0.8;
        this.addChild(bg);

        const selectedIcon = new Graphics();
        selectedIcon.beginFill(0x0000ff, 1);
        selectedIcon.drawRect(-16, -16, 32, 32);
        selectedIcon.endFill();
        selectedIcon.visible = false;
        this.addChild(selectedIcon);

        for (let i = 0; i < desktopIcons.length; i++) {
            const desktopIcon = desktopIcons[i];
            const container = new GameObject();
            desktopIcon.components?.forEach((e) => container.addComponent(e));

            const icon = new Sprite(desktopIcon.icon);
            icon.width =
                icon.height =
                    32;
            icon.position.set(16, 0);
            container.addChild(icon);

            let clickCounter = 0;
            buttonify(container, {
                onFire: () => {
                    selectedIcon.visible = true;
                    selectedIcon.width = container.width + 10;
                    selectedIcon.height = container.height + 10;
                    selectedIcon.position.set(
                        container.x + icon.position.x + (icon.width * 0.5) - 2,
                        container.y + icon.position.y + (container.height * 0.5) - 2
                    );
                    if(!clickCounter) {
                        setTimeout(() => clickCounter = 0, DOUBLE_CLICK_TIMER);
                    }
                    clickCounter++;
                    if(clickCounter == 2) {
                        desktopIcon.onClick();
                    }
                }
            });

            const text = new Text(desktopIcon.name, new TextStyle({
                fontFamily: GAME_FONT,
                fontSize: 11,
                fill: 0xffffff,
                align: "center",
                wordWrap: true,
                wordWrapWidth: 80,
            }));
            text.anchor.set(0.5, 0);
            text.position.set(
                icon.position.x + (icon.width * 0.5),
                icon.height,
            );
            container.addChild(text);

            container.position.set(
                4,
                4 + (80 * i),
            );
            this.addChild(container);
        }
    }
}